import React from 'react';
import { Award, MapPin, Users, BookOpen } from 'lucide-react';
// Updated with 2025 statistics and latest information
export function About() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-667">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-668">
        {/* Page Header */}
        <div className="mb-12 text-center" data-id="element-669">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-670">
            About Desert Sage Seminars
          </h1>
        </div>

        {/* Hero Section with Photo */}
        <div className="mb-16" data-id="element-671">
          <div className="bg-gradient-to-br from-brand-purple-50 to-white rounded-2xl overflow-hidden shadow-lg" data-id="element-672">
            <div className="grid md:grid-cols-2 gap-8 items-center p-8" data-id="element-673">
              <div data-id="element-674">
                <img src="https://cdn.magicpatterns.com/uploads/3rrVqztecsSvDZ8Krg5Ymg/Fixed_Jon_and_Dana-0136.jpg" alt="Jon and Dana Kichen" className="rounded-lg shadow-md w-full" data-id="element-675" />
              </div>
              <div data-id="element-676">
                <h2 className="text-3xl font-bold text-brand-purple-900 mb-4" data-id="element-677">
                  Jon and Dana Kichen
                </h2>
                <p className="text-xl text-gray-700 font-medium mb-6" data-id="element-678">
                  OUR STORY
                </p>
                <div className="bg-brand-orange-50 border-l-4 border-brand-orange-500 p-4 rounded" data-id="element-679">
                  <p className="text-lg font-semibold text-gray-900" data-id="element-680">
                    In 2025 Desert Sage Seminars helped Arizona real estate
                    licensees complete 84,708 CE classes On-Demand, In-Person
                    and Zoom!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mailing Address */}
        <div className="mb-12 flex items-center justify-center text-gray-700" data-id="element-681">
          <MapPin className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-682" />
          <p className="text-base" data-id="element-683">
            <strong data-id="element-684">Desert Sage Seminars Mailing Address:</strong> 15029 N.
            Thompson Peak B111-487, Scottsdale, AZ 85260
          </p>
        </div>

        {/* Emeritus Award Highlight */}
        <div className="mb-12 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-685">
          <div className="flex items-start" data-id="element-686">
            <Award className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-687" />
            <p className="text-base text-gray-800" data-id="element-688">
              In early 2021, Jon was awarded the{' '}
              <strong data-id="element-689">REALTOR Emeritus designation</strong> from the National
              Association of REALTORS.
            </p>
          </div>
        </div>

        {/* About Jon Section */}
        <div className="mb-16" data-id="element-690">
          <div className="bg-brand-purple-50 rounded-lg p-8 mb-8" data-id="element-691">
            <h2 className="text-3xl font-bold text-brand-purple-900 mb-6" data-id="element-692">
              About Jon
            </h2>

            <div className="space-y-6 text-base leading-relaxed text-gray-700" data-id="element-693">
              <p data-id="element-694">
                Jon obtained his real estate license in 1980 and owned and
                operated Kichen and Associates alongside his parents, Shirley
                and Rubin Kichen. The family business focused primarily on
                condominium conversion sales and residential resales.
              </p>

              <p data-id="element-695">
                During the 1980s, Jon was highly active in SAAR (Scottsdale Area
                Association of REALTORS®) and was honored as Realtor® of the
                Year in 1984. He served on several SAAR committees, including
                Government Affairs and the Realtors Political Action Committee
                (RAPAC), throughout the decade.
              </p>

              <p data-id="element-696">
                In 1986, Jon moved to Merrill Lynch Realty, where he became
                Sales Manager while continuing to sell real estate. When Merrill
                Lynch Realty transitioned to Prudential Realty, Jon played a key
                role in helping the company successfully adopt the
                well-respected national franchise.
              </p>

              <p data-id="element-697">
                In 1990, Jon joined Coldwell Banker and was appointed Branch
                Manager of the Camelback Branch. Within one year, he transformed
                an office that was losing money into one of the most profitable
                offices in the Western Region of Coldwell Banker—a distinction
                it maintained for many years. Jon was instrumental in moving
                Coldwell Banker Success Realty to the forefront of leadership in
                the Phoenix real estate community. He remained with Coldwell
                Banker Success Realty until spring 2002.
              </p>

              <p data-id="element-698">
                In June 2002, Jon joined the brokerage team at West USA Realty.
                While he played an active role on the brokerage team, Jon
                decided to pursue a different path in the real estate business.
                In 2006, inspiration struck to create a real estate school that
                would provide quality education to licensees. Desert Sage
                Seminars became an approved school in February 2006.
              </p>

              <p data-id="element-699">
                In fall 2013, Jon parted ways with West USA Realty. Once word
                spread throughout the industry that Jon was available, he was
                pursued by numerous companies. Jon chose to focus on Desert Sage
                Seminars while accepting the position of Designated Broker for
                DeLex Realty, a new brokerage that needed guidance. Jon
                established essential systems and helped grow the company. In
                summer 2015, he decided to focus solely on education and
                resigned his position as Designated Broker of DeLex Realty.
                Today, he remains dedicated to teaching continuing education
                classes.
              </p>

              <div className="bg-white rounded-lg p-6 border-l-4 border-brand-orange-500 my-8" data-id="element-700">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-701">
                  The Turning Point
                </h3>
                <p className="mb-4" data-id="element-702">
                  In July 2006, Jon had a near-death experience when a medical
                  procedure went horribly wrong. His condition deteriorated so
                  severely that it required a "code blue"—meaning the patient
                  has no heart rate and is turning blue. Through considerable
                  luck and the exceptional skill of the surgeon on the cardiac
                  crash team, he survived both the procedure and the resulting
                  emergency surgery.
                </p>
                <p className="mb-4" data-id="element-703">
                  During the six weeks he spent recovering at home, there was
                  plenty of time to reflect. First, he recognized that every day
                  is a gift. But he also realized that had he not survived, what
                  legacy would he have left for his family? Sure, he had life
                  insurance, retirement assets, and other savings, but what
                  viable source of income would continue after his paychecks
                  stopped? At that point, nothing.
                </p>
                <p className="mb-4" data-id="element-704">
                  Jon began pondering what he could do—what type of company he
                  could build that would continue generating income even after
                  he was gone. Since he was already a real estate trainer
                  instructing in-person classes and knew that the Arizona
                  Department of Real Estate permitted on-demand classes, that
                  seemed like a natural direction. In August 2006, the idea for
                  the Desert Sage Seminars website was born.
                </p>
                <p className="mb-4" data-id="element-705">
                  For the remainder of 2006, he conducted feasibility studies to
                  determine if there was room for another company in the market.
                  The answer was yes. He began taking on-demand classes to
                  review the competition and spoke with real estate agents
                  throughout the state. Through this research, he identified
                  what was missing and what was needed in a new website. By
                  early 2007, he had developed a business plan and researched
                  the cost of building the website.
                </p>
                <p className="mb-4" data-id="element-706">
                  That process took about five months. In June 2007, he
                  contracted with a company to build the website and began
                  writing courses. By the end of 2007, he submitted his first
                  six classes to the Arizona Department of Real Estate. The
                  classes were approved by February, and on February 21, 2008,
                  the Desert Sage Seminars website officially launched.
                </p>
                <p className="mb-4" data-id="element-707">
                  Thanks to pent-up demand from agents Jon had already spoken
                  with, Desert Sage Seminars had customers on day one—and that
                  success continues today. Desert Sage Seminars has earned an
                  excellent reputation as an industry leader, offering quality
                  education, the most user-friendly website, and unparalleled
                  customer service.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-708">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-709">Jon is</h3>
                <ul className="space-y-2 list-disc list-inside" data-id="element-710">
                  <li data-id="element-711">A Certified GRI Instructor</li>
                  <li data-id="element-712">
                    A Certified AAR Ethics Instructor for National Association
                    of Realtors (NAR)
                  </li>
                  <li data-id="element-713">
                    A REALTOR Emeritus, awarded by the National Association of
                    REALTORS, after 40 years of service, and at least one year
                    on a NAR Committee
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-714">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-715">
                  Previously, Jon
                </h3>
                <ul className="space-y-2 list-disc list-inside" data-id="element-716">
                  <li data-id="element-717">Chaired the AAR Solar Addendum Workgroup, 2021</li>
                  <li data-id="element-718">
                    Served on the AAR Risk Management Data/Cybersecurity Task
                    Force, 2018
                  </li>
                  <li data-id="element-719">
                    Served on the ADRE Education Advisory Committee, 2010 - 2020
                  </li>
                  <li data-id="element-720">
                    Served on AAR Purchase Contract Sub-Group, 2016, which
                    revised the current Residential Purchase Contract.
                  </li>
                  <li data-id="element-721">Served on AAR HOA Addendum Task Force Committee, 2014</li>
                  <li data-id="element-722">
                    Served on AAR Risk Management Committee, 2014-2018, 2019 -
                    2023
                  </li>
                  <li data-id="element-723">Served on AAR Fair Housing Advisory Workgroup, 2021</li>
                  <li data-id="element-724">Served on AAR Purchase Contract Task Force, 2014</li>
                </ul>
              </div>

              <p className="font-medium text-gray-900" data-id="element-725">
                Jon has owned, operated, educated, managed and practiced real
                estate his entire career. Volunteering on the local, state and
                national committee over his career has made Jon an advocate for
                the entire real estate industry.
              </p>
            </div>
          </div>
        </div>

        {/* About Dana Section */}
        <div className="mb-16" data-id="element-726">
          <div className="bg-gray-50 rounded-lg p-8" data-id="element-727">
            <h2 className="text-3xl font-bold text-brand-purple-900 mb-6" data-id="element-728">
              About Dana
            </h2>

            <div className="space-y-6 text-base leading-relaxed text-gray-700" data-id="element-729">
              <p data-id="element-730">
                Before moving to Arizona in 1980, Dana was a Quality Control
                Analyst, Color Specialist and Customer Service Advisor for
                Helena Rubinstein cosmetics. Using her expertise, she began
                working for Revlon Cosmetics (Southwest Division) as the Color
                Analyst for all first production color products. Thereafter,
                Dana had her own Private Label Cosmetics business and sold
                products to beauty salons in the Phoenix Metro area.
              </p>

              <p data-id="element-731">
                Subsequently, Dana became the Southwest Regional Training
                Coordinator for Estee Lauder Cosmetics and worked with the major
                retail stores training the staff for customer service, products,
                artistry and sales for 10 years. With her team, they created a
                training course that was adopted and used nationally by the
                company.
              </p>

              <p data-id="element-732">
                Dana joined The Dial Corporation (Henkel) where she handled
                escalated consumer issues and legal claims and helped manage the
                16-telephone call-center agents in the Consumer Information
                Center. She collaborated with Risk Management, Marketing, Sales
                and R&D for product issues and information and was part of the
                team to train her division on product and customer service
                skills for over 12 years.
              </p>

              <p className="font-medium text-gray-900" data-id="element-733">
                Applying her training skills, product development insights, and
                creative customer service, Dana is currently the President of
                Marketing and Director of Customer Service for Desert Sage
                Seminars. Dana believes that quality informative
                Arizona-specific classes, a user-friendly website and
                exceptional customer service is an integral part of what
                distinguishes Desert Sage Seminars from their competition.
              </p>

              <p data-id="element-734">
                Dana was selected and participated in the Scottsdale Area
                Association of Realtors® Leadership Academy-Class XVIII. Dana
                has been an active member and Strategic Partner in Women's
                Council of Realtors® since 2008. She served on the board as the
                Education Chair for Women's Council of Realtors®-Phoenix in
                2016 and 2017 and served as the Arizona State Women's Council of
                Realtors® 2016 State Education Chair (Arizona)
              </p>

              <p data-id="element-735">
                Dana was awarded Affiliate of the Year for the Scottsdale
                Women's Council of REALTORS Network in 2011.
              </p>

              <p data-id="element-736">
                Dana truly enjoys networking in the Realtor® community. She
                manages the Facebook group ARIZONA RE CE Classes that has over
                1,900 members. Her goal is to be sure that agents have access to
                any CE classes that are being held in the Valley.
              </p>
            </div>
          </div>
        </div>

        {/* Personal Life Section */}
        <div className="bg-brand-purple-50 rounded-lg p-8" data-id="element-737">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-738">
            Beyond Real Estate
          </h2>
          <div className="space-y-4 text-base leading-relaxed text-gray-700" data-id="element-739">
            <p data-id="element-740">
              Jon is an avid photographer of nature, animals and extreme
              locations. Jon and Dana have trekked on a glacier, explored an
              active volcano, and hiked through a rainforest. Jon has also
              visited and photographed the Mayan Ruins in Chichen Itza, Mexico.
            </p>
            <p data-id="element-741">
              Jon and Dana live in Scottsdale. Their son, Jason, is married to
              Stefeny and they have a teenager who is the light of all our
              lives.
            </p>
          </div>
        </div>
      </div>
    </div>;
}